import { render, staticRenderFns } from "./teacherControlPanel.vue?vue&type=template&id=3f1d12f2&scoped=true"
import script from "./teacherControlPanel.vue?vue&type=script&lang=js"
export * from "./teacherControlPanel.vue?vue&type=script&lang=js"
import style0 from "./teacherControlPanel.vue?vue&type=style&index=0&id=3f1d12f2&prod&scoped=true&lang=css"
import style1 from "./teacherControlPanel.vue?vue&type=style&index=1&id=3f1d12f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d12f2",
  null
  
)

export default component.exports